/**
 * TechnicianHeader Component
 *
 * Top navigation bar for the Technician Portal.
 * Matches admin portal's white navbar pattern with logo, notifications,
 * and user avatar dropdown.
 *
 * @module components/technician/layout/TechnicianHeader
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiUser, FiLogOut } from 'react-icons/fi';
import PropTypes from 'prop-types';
import AgentTriggerButton from '../../layout/AgentTriggerButton';
import NotificationBell from '../../notifications/NotificationBell';
import './TechnicianLayout.css';

const logoPath = `${process.env.PUBLIC_URL}/images/logos/Logo_PROMEDIC-07.png`;

const TechnicianHeader = ({ userName = 'Usuario', onLogout }) => {
  const navigate = useNavigate();
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);

  const handleProfileClick = () => {
    setProfileMenuOpen(!profileMenuOpen);
  };

  const handleProfileMenuClose = () => {
    setProfileMenuOpen(false);
  };

  const handleProfileNavigate = () => {
    setProfileMenuOpen(false);
    navigate('/tecnico/perfil');
  };

  const handleLogoutClick = () => {
    setProfileMenuOpen(false);
    onLogout();
  };

  // Get initials for avatar (up to 2 chars)
  const initials = userName
    ? userName.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';
  const displayName = userName || 'Usuario';

  return (
    <header className="technician-header">
      {/* Logo */}
      <div className="technician-header-logo" onClick={() => navigate('/tecnico/dashboard')}>
        <img src={logoPath} alt="ProMedic" />
      </div>

      {/* Right Actions */}
      <div className="technician-header-actions">
        {/* Tu agente (mismo botón que el portal principal) */}
        <AgentTriggerButton />

        {/* Notifications */}
        <NotificationBell />

        {/* User Avatar Dropdown */}
        <div className="technician-profile-dropdown">
          <button
            className="technician-avatar-btn"
            onClick={handleProfileClick}
            aria-expanded={profileMenuOpen}
            aria-haspopup="true"
          >
            <span className="technician-avatar-circle">{initials}</span>
            <span className="technician-avatar-name">{displayName}</span>
          </button>

          {profileMenuOpen && (
            <>
              <div className="profile-menu-backdrop" onClick={handleProfileMenuClose} />
              <div className="profile-menu">
                <button className="profile-menu-item" onClick={handleProfileNavigate}>
                  <FiUser size={18} />
                  <span>Mi Perfil</span>
                </button>
                <div className="profile-menu-divider" />
                <button className="profile-menu-item logout" onClick={handleLogoutClick}>
                  <FiLogOut size={18} />
                  <span>Cerrar Sesión</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

TechnicianHeader.propTypes = {
  userName: PropTypes.string,
  onLogout: PropTypes.func.isRequired
};

export default TechnicianHeader;
